import { render } from "./elegant.vue?vue&type=template&id=15d3d353&scoped=true"
import script from "./elegant.vue?vue&type=script&lang=js"
export * from "./elegant.vue?vue&type=script&lang=js"

import "./elegant.vue?vue&type=style&index=0&id=15d3d353&lang=scss&scoped=true"
import "./elegant.vue?vue&type=style&index=1&id=15d3d353&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d3d353"]])

export default __exports__